export default "__VITE_ASSET__crkzL0aU__"